import React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";

import { withApollo } from "react-apollo";

import { getAccessPermisionQuery } from "../../services/graphql/queries/accessPermission";
import { getCategoryById } from "../../services/graphql/queries/category-management";

import Subcategory from "./Subcategory/Subcategory"

const DOCUMENT_MODULE_ID = 2;

class DocumentProfile extends React.Component {
  constructor() {
    super();
    this.state = {
      loading: false,
      errors: [],
      category: {},
      accessSpecifier: {}
    };
  }

  getCategoryById() {
    var category = localStorage.getItem('categoryId');
    category = JSON.parse(category);
    this.props.client
      .query({
        query: getCategoryById,
        variables: {
          id: category.id
        },
        fetchPolicy: "network-only"
      })
      .then(result => {
        const category = result.data.getCategoryById;

        this.initialState = {
          category: category
        };
        this.setState({ ...this.initialState, loading: false, error: "" });
      })
      .catch(error => {
        console.log("~~~error: ", error);
        this.setState({ loading: false, error: error.message });
      });
  }

  componentDidMount() {
    this.setState({ loading: true });
    this.props.client
      .query({
        query: getAccessPermisionQuery,
        variables: {
          moduleId: DOCUMENT_MODULE_ID
        },
        fetchPolicy: "network-only"
      })
      .then(result => {
        let response = result.data.getFunctionByModuleId;
        response = JSON.parse(response);
        this.setState({
          accessSpecifier: response
        });
        var category = localStorage.getItem('categoryId');
        category = JSON.parse(category);
        this.setState({
          category: category
        });
        // this.getCategoryById();
      })
      .catch(error => {
        this.setState({
          loading: false,
          error: error.message
        });
      });
  }

  render() {
    const {
      category,
    } = this.state;
    return (
      <>
        <div className="main-heading task-list">
          <h1>
            {/* CATEGORY DETAIL-{category.id ? category.id : ""} */}
           Project: {category.name ? category.name : ""}
          </h1>
        </div>
        <section className="main-section pt-0 pl-0 pr-0">
        {category.id ?
          <Subcategory 
            category={category}
          />
        :null}
        </section>
      </>
    );
  }
}

DocumentProfile.getInitialProps = ({ router }) => {
  return { router };
};

export default withRouter(connect()(withApollo(DocumentProfile)));